import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { AiOutlineClear } from 'react-icons/ai';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';

import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import { MdPhoneForwarded } from 'react-icons/md';
import Loader from 'components/Loader';
import ClickToCall from '../../../../ServicePanel/components/AttendanceContent/components/Modal/ClickToCall';
import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style
} from '../../../../../assets/styles/table_custom_style';
import { apiChat } from '../../../../../http';
import SimpleHeader from '../../../../../components/Headers/SimpleHeader';
import { formatCurrency } from 'utils/fuctions/formatCurrency';
import { useProtocolDefaultFieldsSettings } from '../../../../fieldConfigs/hooks/useProtocolDefaultFieldsSettings';
import { dateRules } from '../../../assets';
import { functionsUseFul } from '../../assets/functionsUseFul';
import { useHandleProtocolListing } from '../../hooks/useHandleProtocolListing';
import { ClientNameWrapper } from '../ClientNameWrapper';
import FiltersForm from '../FiltersForm';
import { OutlineTooltip } from '../OutlineTooltip';
import ProtocolHistoryModal from '../ProtocolHistoryModal';
import { ProtocolNumberWrapper } from '../ProtocolNumberWrapper';
import Table from '../Table';
import { useSelector } from 'react-redux';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import {
  EditProtocolByNumber,
  ProgressBar,
  ProgressBarContainer,
  ProgressBarBackground
} from './styled';
import { maskPhoneNumber } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { maskCpf } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { maskCnpj } from 'views/CRM/shared/utils/cpfCnpjHelpers';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useListStatusByRecordType } from 'views/status/list/hooks/useListStatusByRecordType';
import { InfoCardProtocol } from '../InfoCard';
import ProtocolService from '../../../service';
import { ListView } from '../ListView';
import { FaLink } from 'react-icons/fa';
import { Graphics } from 'views/Report/Protocol/Synthetic/components/Graphics';
import styled from 'styled-components';
import {
  POSSIBLE_FILTERS_ENTITIES,
  useMemorizeFilters
} from '../../../../../hooks/useMemorizeInputsFilters';
import { KanbanProtocol } from '../../components/ProtocolList/components/kanbanProtocol';

import RecordTypeService from '../../../../RecordType/service';
import { SLA_COLORS } from '../../../updateForm/components/ModalSLAInfo/utils';

const ProtocolFieldsFilterToggle = styled.div`
  display: inline-block;
  margin-right: 1rem;
  user-select: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const ProtocolListing = ({
  recordTypes,
  selectedRecordType,
  handleSelectedRecordTypeChange,
  isPageReloaded,
  hasChangedRecordType,
  setHasChangedRecordType,
  isListenerOnRecordType = false,
  setIsListenerOnRecordType
}) => {
  const selectedRecordTypeId = selectedRecordType.value;
  const history = useHistory();
  const formRef = useRef(null);
  const { protocolDefaultFieldsDisplaySettings } =
    useProtocolDefaultFieldsSettings(selectedRecordTypeId);
  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.PROTOCOL,
    selectedRecordTypeId
  );

  const {
    protocols,
    protocolsQuantity,
    isLoadingProtocols,
    getProtocols,
    getProtocolOverallSLAInfoByRecordType,
    protocolOverallSLAInfo,
    formatParamsSLAParams,
    getAndReturnProtocolsKanban
  } = useHandleProtocolListing(selectedRecordTypeId);
  const { status, getStatusByRecordType } =
    useListStatusByRecordType(selectedRecordTypeId);

  const [rowsSelectds, setRowsSelectds] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [dataField, setDataField] = useState();
  const [placement] = useState('bottom');
  const { buildProtocolTitleString } = functionsUseFul();
  const [disableClickToCall, setDisableClickToCall] = useState(true);
  const [orderByFilter, setOrderByFilter] = useState('creation_date');
  const [orderByColumn, setOrderByColumn] = useState('');
  const [sortOrder, setSortOrder] = useState('DESC');
  const [selectedView, setSelectedView] = useState('TABLE');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [typeReportSelected, setTypeReportSelected] = useState('Analítico');
  const [dataGrafics, setDataGrafics] = useState();
  const [, setLoaderGrafics] = useState();
  const [showProtocolFilters, setShowProtocolFilters] = useState(true);
  const { memorizeFilters, getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.PROTOCOL
  );

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [sortDirection, setSortDirection] = useState('DESC');
  const [kanbanData, setKanbanData] = useState([]);
  const kanbanDataArray = Object.values(kanbanData).flat() ?? [];
  const [stagePageInfo, setStagePageInfo] = useState([]);
  const [stagePageInfoSplitView, setStagePageInfoSplitView] = useState([]);
  const [splitViewData, setSplitViewData] = useState([]);

  const [isLoadingKanban, setIsLoadingKanban] = useState(false);
  const [isLoadingSplitView, setIsLoadingsplitView] = useState(false);

  const sizeKanban = 20;
  const sizeSplitView = 30;

  const [isRecordTypeUsingSLA, setIsRecordTypeUsingSLA] = useState(false);

  useEffect(() => {
    if (!selectedRecordTypeId) return;
    setStagePageInfoSplitView([]);
    setSplitViewData([]);
    setKanbanData([]);
    setStagePageInfo([]);
    getStatusByRecordType(selectedRecordTypeId);
    const filters = getMemorizedFilters();
    const filteredCustomFields = getFilteredCustomFieldsListType();

    const page = filters?.page || activePage;
    const size = filters?.size || itemsPerPage;

    setItemsPerPage(size);

    let filterDto = { ...filters };
    if (!isPageReloaded && isListenerOnRecordType) {
      const keysToRemove = new Set([
        'reason_id',
        'subreason_id',
        'current_status',
        'idChannel',
        'current_responsible',
        'service_channel',
        'matrixSLA',
        'impact',
        'criticality',
        'slaAtendimento',
        'slaSolucao',
        ...filteredCustomFields
      ]);

      filterDto = Object.fromEntries(
        Object.entries(filterDto).filter(([key]) => !keysToRemove.has(key))
      );
    }

    memorizeFilters({
      ...filterDto,
      page,
      selectedRecordType
    });
    delete filterDto.selectedRecordType;
    if (selectedView === 'TABLE') {
      getProtocols({
        ...(filterDto || {}),
        page,
        size,
        order_by: orderByFilter,
        order_type: sortDirection
      });
    }
    if (selectedView === 'KANBAN') {
      getAndReturnProtocolsKanban({
        ...(filterDto || {}),
        page,
        size: sizeKanban
      });
    }

    getProtocolOverallSLAInfoByRecordType({
      ...(filterDto || {}),
      page: undefined,
      size: undefined,
      order_by: orderByFilter,
      order_type: sortOrder
    });

    // eslint-disable-next-line no-prototype-builtins
    if (filters?.hasOwnProperty('showProtocolFilters')) {
      setShowProtocolFilters(filters?.showProtocolFilters);
    }
  }, [getStatusByRecordType, getMemorizedFilters, selectedRecordTypeId]);

  useEffect(() => {
    if (!selectedRecordTypeId) return;
    RecordTypeService.getById(selectedRecordTypeId)
      .then((response) => {
        const recordType = response.data.content;
        if (recordType) {
          setIsRecordTypeUsingSLA(recordType.is_sla_active);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedRecordTypeId]);

  const telephonyServicePanel = useSelector(
    (state) => state.telephonyServicePanel
  );

  useEffect(() => {
    const copy = [...rowsSelectds];
    copy.splice(0, rowsSelectds.length);
    setRowsSelectds(copy);
  }, [selectedRecordType]);

  const canSeeAllProtocols = useMemo(() => {
    const flag = localStorage.getItem('show_all_protocols');
    return flag === 'true';
  }, []);

  const acessToken = useMemo(() => {
    const initialToken = localStorage.getItem('token');
    const finalToken = `Bearer ${initialToken}`;
    return finalToken;
  }, []);

  const getFilteredCustomFieldsListType = useCallback(() => {
    return customFields
      .filter((field) => field.type === 'MULTIPLE' || field.type === 'LIST')
      .map((field) => field.name);
  }, [customFields, getCustomFields]);

  const handleHeaderCheckboxChange = (e) => {
    const isChecked = e.target.checked;

    const allRowIds = protocols.map((r) => ({
      id: r.id,
      current_status: r.current_status ? r.current_status : null,
      number: r.number ? r.number : null,
      current_responsible: r.current_responsible ? r.current_responsible : null,
      account_id: r.account_id ? r.account_id : null
    }));

    if (isChecked) {
      const newSelection = allRowIds.filter(
        (item) => !rowsSelectds.some((selected) => selected.id === item.id)
      );
      setRowsSelectds([...rowsSelectds, ...newSelection]);
    } else {
      setRowsSelectds([]);
    }
  };

  const handleSearchKanban = (searchFilters) => {
    getAndReturnProtocolsKanban({
      ...searchFilters,
      page: 1,
      size: sizeKanban
    }).then((response) => {
      const { content, quantityKamban } = response.data;

      const kanbanArray = Object.entries(content).map(
        ([stageId, protocols]) => {
          const actualStageId = stageId === 'no_status' ? 'no_status' : stageId;
          const stage = status.find((s) => s.id === actualStageId) || {
            id: 'no-status',
            name: 'Sem Status'
          };
          const count =
            quantityKamban.find(
              (q) =>
                q.id === stageId || (stageId === 'no_status' && q.id === null)
            )?.quantidade || protocols.length;
          return {
            id: stage.id,
            name: stage.name,
            protocols,
            count: parseInt(count, 10),
            currentPage: 1
          };
        }
      );

      setStagePageInfo(
        kanbanArray.map(({ id, name, count, currentPage }) => ({
          id,
          name,
          count,
          currentPage
        }))
      );

      setKanbanData(kanbanArray);
    });
  };

  const handleSearchSplitView = (searchFilters) => {
    // ele chama a mesma função que o kanban, mas com um tamanho diferente
    getAndReturnProtocolsKanban({
      ...searchFilters,
      page: 1,
      size: sizeSplitView
    }).then((response) => {
      const { content, quantityKamban } = response.data;

      const splitScreenArray = Object.entries(content).map(
        ([stageId, protocols]) => {
          const actualStageId = stageId === 'no_status' ? 'no_status' : stageId;
          const stage = status.find((s) => s.id === actualStageId) || {
            id: 'no-status',
            name: 'Sem Status'
          };
          const count =
            quantityKamban.find(
              (q) =>
                q.id === stageId || (stageId === 'no_status' && q.id === null)
            )?.quantidade || protocols.length;
          return {
            id: stage.id,
            name: stage.name,
            protocols,
            count: parseInt(count, 10),
            currentPage: 1
          };
        }
      );

      setStagePageInfoSplitView(
        splitScreenArray.map(({ id, name, count, currentPage }) => ({
          id,
          name,
          count,
          currentPage
        }))
      );

      setSplitViewData(splitScreenArray);
    });
  };

  const handleGetProtocols = useCallback(
    async (
      params = {},
      showToastMessage = true,
      isKanban = false,
      isSplitView = false
    ) => {
      setDataField({ ...params });
      if (isKanban) {
        handleSearchKanban(params);
        return;
      }
      if (isSplitView) {
        handleSearchSplitView(params);
        return;
      }
      await getProtocols(params, showToastMessage);
    },
    [getProtocols, selectedView, status]
  );

  const handleGetProtocolsOverallSLAInfo = useCallback(
    async (params = {}) => {
      setDataField({ ...params });
      getProtocolOverallSLAInfoByRecordType(params);
    },
    [getProtocolOverallSLAInfoByRecordType]
  );

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    if (telephonyServicePanel.extension === '') {
      setDisableClickToCall(true);
    } else {
      setDisableClickToCall(false);
    }
  }, [telephonyServicePanel]);

  const handleCall = useCallback(
    (row) => {
      let telephoneWithoutSpecialCharacters =
        row.telephone && row.telephone !== ''
          ? row.telephone.replace(/\D/g, '')
          : '';
      let clientTelephoneWithoutSpecialCharacters =
        row.telefoneCliente && row.telefoneCliente !== ''
          ? row.telefoneCliente.replace(/\D/g, '')
          : '';
      const data = {
        origem: telephonyServicePanel.extension,
        destino:
          row.telephone && row.telephone !== ''
            ? telephoneWithoutSpecialCharacters
            : clientTelephoneWithoutSpecialCharacters
      };
      if (disableClickToCall) {
        toast.error(
          'É necessário estar logado em um ramal para realizar a chamada!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      } else {
        if (!window.confirm('Tem certeza que deseja realizar a chamada agora?'))
          return;

        apiChat
          .post(`/clicktocall`, data)
          .then(() => {
            toast.success('Realizando chamada!', {
              autoClose: 3000,
              closeOnClick: true
            });
          })
          .catch((err) => {
            toast.error(err.response.data.msg || 'Erro ao realizar chamada!');
          });
      }
    },
    [disableClickToCall, telephonyServicePanel.extension]
  );

  const handleUpdate = useCallback(
    (id) => {
      const values = {
        recordTypeId: selectedRecordTypeId,
        returnPath: '/admin/protocol'
      };
      const objetoString = JSON.stringify(values);
      localStorage.setItem('valueRoute', objetoString);

      history.push(`/admin/protocol/${id}/update`);
    },
    [history, selectedRecordTypeId]
  );

  const handlePageChange = (activePage) => {
    const currentFilters = getMemorizedFilters();
    const size = currentFilters?.size ? currentFilters.size : itemsPerPage;
    getProtocols({
      ...(dataField || {}),
      filterColumn: orderByColumn,
      page: activePage,
      size,
      order_by: orderByFilter,
      order_type: sortDirection
    });
    memorizeFilters({
      ...currentFilters,
      page: activePage
    });
    setActivePage(activePage);
  };

  function removeMultipleParams(obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([, value]) => !Array.isArray(value) || value.length > 0
      )
    );
  }

  const getMediaPath = useCallback(
    (media) => {
      try {
        const [, jwt] = acessToken.split(' ');
        let formattedDataField = formatParamsSLAParams(dataField);
        const dataFieldWithoutMultipleParams =
          removeMultipleParams(formattedDataField);

        const paramsAsString = new URLSearchParams();

        for (const key in dataFieldWithoutMultipleParams) {
          if (Array.isArray(dataFieldWithoutMultipleParams[key])) {
            dataFieldWithoutMultipleParams[key].forEach((element) => {
              paramsAsString.append(`${key}[]`, element);
            });
          } else {
            paramsAsString.append(key, dataFieldWithoutMultipleParams[key]);
          }
        }

        paramsAsString.append('jwt', jwt);

        const queryURL = `${process.env.REACT_APP_CASE_URL}protocols/export/${media}/${selectedRecordTypeId}?${paramsAsString}`;
        return queryURL;
      } catch (err) {
        toast.error('Ops, ocorreu um erro ao realizar o download do arquivo!', {
          autoClose: 3000,
          closeOnClick: true
        });
      }
    },
    [acessToken, dataField, orderByFilter, sortOrder, selectedRecordTypeId]
  );

  const selectProtocol = {
    formatExtraData: rowsSelectds,

    headerFormatter: () => {
      return (
        <input
          defaultValue={false}
          checked={protocols?.every((obj) =>
            rowsSelectds.some((row) => row.id === obj.id)
          )}
          type="checkbox"
          onChange={handleHeaderCheckboxChange}
        ></input>
      );
    },
    style: individual_column_style,
    formatter: (_, row, rowIndex, formatExtraData) => {
      const isChecked = formatExtraData.some((item) => item.id === row.id);
      return (
        <input
          checked={isChecked}
          onChange={(value) => {
            const id = row.id;
            const currentStatus = row.current_status;
            const number = row.number;
            const current_responsible = row.current_responsible;
            const account_id = row.account_id;
            const newItem = {
              id,
              currentStatus,
              number,
              current_responsible,
              account_id
            };

            if (value.target.checked && !isChecked) {
              const copy = [...formatExtraData, newItem];
              setRowsSelectds(copy);
            } else if (!value.target.checked && isChecked) {
              const copy = formatExtraData.filter((item) => item.id !== id);
              setRowsSelectds(copy);
            }
          }}
          value={row.id}
          type="checkbox"
        />
      );
    }
  };

  const createDynamicColumns = useCallback(() => {
    const columns = [
      {
        dataField: 'number',
        text: 'Número',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          const showIcon = !!row?.parent_id || !!row?.subProtocols?.length;
          const { number, description } = row;
          return (
            <Link
              to={`/admin/protocol/${row.id}/update`}
              onClick={() => handleUpdate(row.id)}
            >
              <EditProtocolByNumber
                style={{ color: '#515151' }}
                onClick={() => handleUpdate(row.id)}
                title={`Clique para editar o protocolo ${number}`}
              >
                {showIcon && <FaLink style={{ marginRight: '3px' }}></FaLink>}
                <ProtocolNumberWrapper
                  number={number}
                  description={description}
                  onClick={() => handleUpdate(row.id)}
                  isDescriptionShown={
                    protocolDefaultFieldsDisplaySettings &&
                    protocolDefaultFieldsDisplaySettings.description &&
                    protocolDefaultFieldsDisplaySettings.description.isRequired
                  }
                />
              </EditProtocolByNumber>
            </Link>
          );
        }
      }
    ];

    columns.splice(0, 0, selectProtocol);

    if (
      protocolDefaultFieldsDisplaySettings &&
      Object.keys(protocolDefaultFieldsDisplaySettings).length
    ) {
      if (protocolDefaultFieldsDisplaySettings.title.isActive) {
        columns.push({
          dataField: 'title',
          text: 'Título',
          sort: true,
          style: individual_column_style,
          // eslint-disable-next-line react/display-name
          formatter: (_, row) => {
            return (
              <>
                <div>
                  <span style={{}} id={`title-${row.id}`}>
                    {buildProtocolTitleString(row.title)}
                  </span>

                  <OutlineTooltip
                    placement={placement}
                    target={`title-${row.id}`}
                    message={row.title}
                  />
                </div>
              </>
            );
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        Object.keys(protocolDefaultFieldsDisplaySettings).length
      ) {
        if (protocolDefaultFieldsDisplaySettings.current_status.isActive) {
          columns.push({
            dataField: 'status',
            text: 'Status/Fase',
            sort: true,
            style: individual_column_style,
            formatter: (_, row) => {
              const { nomeStatus, corStatus } = row;
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <>
                    <div
                      style={{
                        marginRight: '5px',
                        width: '12px',
                        height: '12px',
                        border: '1px solid #CDC9C9',
                        backgroundColor: `${corStatus}`
                      }}
                    ></div>
                    <div>{`${nomeStatus}`}</div>
                  </>
                </div>
              );
            }
          });
        }
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.client_id.isActive
      ) {
        columns.push({
          dataField: 'cliente',
          text: 'Contato',
          sort: true,
          style: individual_column_style,
          formatter: (_, row) => {
            const { nomeCliente, telefoneCliente, emailCliente } = row;
            return (
              <ClientNameWrapper
                name={nomeCliente}
                telephone={telefoneCliente}
                email={emailCliente}
              />
            );
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.account_id.isActive
      ) {
        columns.push({
          dataField: 'nomeConta',
          text: 'Conta',
          sort: true,
          style: individual_column_style,
          formatter: (_, row) => {
            const { nomeConta } = row;
            return nomeConta || '';
          }
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.reason_id.isActive
      ) {
        columns.push({
          dataField: 'nomeMotivo',
          text: 'Motivo',
          sort: true,
          style: individual_column_style
        });
      }

      if (
        protocolDefaultFieldsDisplaySettings &&
        protocolDefaultFieldsDisplaySettings.subreason_id.isActive
      ) {
        columns.push({
          dataField: 'nomeSubmotivo',
          text: 'Submotivo',
          sort: true,
          style: individual_column_style
        });
      }

      columns.push({
        dataField: 'creation_date',
        text: 'Criação',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (!row.creation_date) {
            return '';
          }
          const date = new Date(row.creation_date);
          return `${date.toLocaleDateString(
            'pt-BR'
          )} às ${date.toLocaleTimeString('pt-BR', {
            timeZone: 'America/Fortaleza'
          })}`;
        }
      });

      columns.push({
        dataField: 'nomeResponsavel',
        text: 'Responsável',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          return row.nomeResponsavel || '';
        }
      });

      columns.push({
        dataField: 'last_change_date',
        text: 'Última Alteração',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          const date = new Date(row.last_change_date);
          return `${date.toLocaleDateString(
            'pt-BR'
          )} às ${date.toLocaleTimeString('pt-BR', {
            timeZone: 'America/Fortaleza'
          })}`;
        }
      });
    }

    (customFields || []).forEach((field) => {
      columns.push({
        dataField: field.name,
        text: field.label,
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (field.type === 'DATE' && !!row[field.name]) {
            return new Date(row[field.name]).toLocaleDateString('pt-br');
          }

          if (field.type === 'CURRENCY' && !!row[field.name]) {
            return formatCurrency(row[field.name]);
          }

          if (field.type === 'TELEPHONE' && !!row[field.name]) {
            return maskPhoneNumber(row[field.name]);
          }

          if (field.type === 'CPF' && !!row[field.name]) {
            return maskCpf(row[field.name]);
          }

          if (field.type === 'CNPJ' && !!row[field.name]) {
            return maskCnpj(row[field.name]);
          }

          if (field.type === 'MULTIPLE' && !!row[field.name]) {
            return row[field.name].replace(/;/g, '; ');
          }

          return row[`${field.name}`];
        }
      });
    });

    return columns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    customFields,
    protocolDefaultFieldsDisplaySettings,
    buildProtocolTitleString,
    placement,
    handleUpdate
  ]);

  const getSlaColor = (percentage) => {
    if (percentage >= 75) {
      return SLA_COLORS.SLA_100;
    } else if (percentage >= 50) {
      return SLA_COLORS.SLA_75;
    } else if (percentage >= 25) {
      return SLA_COLORS.SLA_50;
    } else {
      return SLA_COLORS.SLA_25;
    }
  };
  const createSLAColumn = useCallback(() => {
    if (!isRecordTypeUsingSLA) {
      return [];
    }
    const slaColumns = [
      {
        dataField: 'service_classification_name',
        text: 'Classificação de Serviço',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) =>
          row.sla_info ? row.sla_info.service_classification_name || '-' : '-'
      },
      {
        dataField: 'serviceTime',
        text: 'SLA de Atendimento',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (row.sla_info && Object.keys(row.sla_info).length) {
            const { serviceTime, remainingServiceTime } = row.sla_info;
            let percentage = (remainingServiceTime / serviceTime) * 100;
            percentage = Math.max(0, Math.min(percentage, 100));
            const color = getSlaColor(percentage);
            return (
              <ProgressBarContainer>
                {`${percentage.toFixed(2)}%`}
                <ProgressBarBackground>
                  <ProgressBar percentage={percentage} color={color} />
                </ProgressBarBackground>
              </ProgressBarContainer>
            );
          }
          return '-';
        }
      },
      {
        dataField: 'solutionTime',
        text: 'SLA de Solução',
        sort: true,
        style: individual_column_style,
        formatter: (_, row) => {
          if (row.sla_info && Object.keys(row.sla_info).length) {
            const { solutionTime, remainingSolutionTime } = row.sla_info;
            let percentage = (remainingSolutionTime / solutionTime) * 100;
            percentage = Math.max(0, Math.min(percentage, 100));
            const color = getSlaColor(percentage);
            return (
              <ProgressBarContainer>
                {`${percentage.toFixed(2)}%`}
                <ProgressBarBackground>
                  <ProgressBar percentage={percentage} color={color} />
                </ProgressBarBackground>
              </ProgressBarContainer>
            );
          }
          return '-';
        }
      }
    ];
    return slaColumns;
  }, [isRecordTypeUsingSLA]);

  const formatColumn = useCallback(() => {
    const dinamicColumns = createDynamicColumns();
    const slaColumns = createSLAColumn();

    const callColumn = {
      dataField: 'call',
      text: 'Chamar',
      style: icon_column_style,
      formatter: (_, row) => {
        return (
          <ClickToCall
            title={
              row?.telefoneCliente !== '' || row.telephone !== ''
                ? `Chamar cliente ${row?.nomeCliente}\nÉ necessário estar logado em um ramal para realizar a chamada!`
                : `O cliente ${row?.nomeCliente} não possui telefone cadastrado`
            }
            callBack={() => handleCall(row)}
            disableClickToCall={
              (row?.telefoneCliente !== '' || row?.telephone !== '') &&
              !disableClickToCall
                ? false
                : true
            }
            icon={<MdPhoneForwarded size={17} color="#fff" />}
            color="success"
            isDefaultButtonStyle={true}
          />
        );
      }
    };

    const editeColumn = {
      dataField: 'edit',
      text: 'Editar',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return (
          <Link to={`/admin/protocol/${row.id}/update`}>
            <Button
              title="Editar protocolo"
              color="info"
              size="sm"
              onClick={() => handleUpdate(row.id)}
            >
              <li className="fas fa-user-edit"></li>
            </Button>
          </Link>
        );
      }
    };

    const historyColumn = {
      dataField: 'history',
      text: 'Histórico',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return <ProtocolHistoryModal protocolId={row.id} />;
      }
    };

    return [
      ...dinamicColumns,
      ...slaColumns,
      editeColumn,
      historyColumn,
      callColumn
    ];
  }, [
    createDynamicColumns,
    createSLAColumn,
    disableClickToCall,
    handleCall,
    handleUpdate
  ]);

  const handleSortProtocolTable = useCallback(
    async (ordenationParam, sortOrder) => {
      setSortOrder(sortOrder);
      setOrderByFilter(ordenationParam);
      await getProtocols({
        ...dataField,
        page: activePage,
        size: 10,
        order_by: ordenationParam,
        order_type: sortOrder
      });
    },
    [activePage, dataField, getProtocols]
  );

  const onTableGrow = async (stageId) => {
    if (isLoadingKanban) return;
    setIsLoadingKanban(true);
    try {
      const stageInfo = stagePageInfo.find((item) => item.id === stageId);
      const page = stageInfo ? stageInfo.currentPage : 0;
      if (!page) {
        return;
      }

      const response = await getAndReturnProtocolsKanban({
        ...dataField,
        current_status: [stageId],
        page: page + 1,
        size: sizeKanban
      });

      const newProtocols = response.data.content[stageId] || [];

      setKanbanData((prev) => {
        return prev.map((stage) => {
          if (stage.id === stageId) {
            return {
              ...stage,
              protocols: [...stage.protocols, ...newProtocols]
            };
          }
          return stage;
        });
      });

      setStagePageInfo((prev) => {
        return prev.map((item) => {
          if (item.id === stageId) {
            return {
              ...item,
              currentPage: page + 1
            };
          }
          return item;
        });
      });

      setIsLoadingKanban(false);
    } catch (error) {
      console.error(error);
      setIsLoadingKanban(false);
    }
  };

  const onTableGrowSplitView = async (stageId) => {
    if (isLoadingSplitView) return;
    setIsLoadingsplitView(true);
    try {
      const stageInfo = stagePageInfoSplitView.find(
        (item) => item.id === stageId
      );
      const page = stageInfo ? stageInfo.currentPage : 0;
      if (!page) {
        return;
      }

      const response = await getAndReturnProtocolsKanban({
        ...dataField,
        current_status: [stageId],
        page: page + 1,
        size: sizeSplitView
      });

      const newProtocols = response.data.content[stageId] || [];

      setSplitViewData((prev) => {
        return prev.map((stage) => {
          if (stage.id === stageId) {
            return {
              ...stage,
              protocols: [...stage.protocols, ...newProtocols]
            };
          }
          return stage;
        });
      });

      setStagePageInfoSplitView((prev) => {
        return prev.map((item) => {
          if (item.id === stageId) {
            return {
              ...item,
              currentPage: page + 1
            };
          }
          return item;
        });
      });

      setIsLoadingsplitView(false);
    } catch (error) {
      console.error(error);
      setIsLoadingsplitView(false);
    }
  };

  const onTableChange = async (protocolId, status_id, _, oldStageId) => {
    try {
      await ProtocolService.protocolUpdateData(
        protocolId,
        { status_id },
        'change_status'
      );

      const oldStage = oldStageId;
      const newStage = status_id;

      const newStageInfo = stagePageInfo.find((item) => item.id === newStage);
      const result = await getAndReturnProtocolsKanban({
        ...dataField,
        page: 1,
        size: newStageInfo.currentPage * sizeKanban
      });

      if (!result?.data?.content || !result?.data?.quantityKamban) {
        toast.error('Resposta inválida do servidor');
        return false;
      }

      setKanbanData((prevKanban) => {
        const contentArray = Object.entries(result.data.content).map(
          ([id, protocols]) => ({
            id,
            protocols,
            ...stagePageInfo.find((stage) => stage.id === id)
          })
        );
        return prevKanban.map((stage) => {
          const updatedStage = contentArray.find((s) => s.id === stage.id);
          if (stage.id === oldStage) {
            return {
              ...stage,
              protocols: stage.protocols.filter((p) => p.id !== protocolId),
              count: stage.count - 1
            };
          }
          if (stage.id === newStage) {
            return {
              ...stage,
              protocols: updatedStage?.protocols || stage.protocols,
              count: updatedStage?.count || stage.count
            };
          }
          return stage;
        });
      });

      setStagePageInfo((prev) =>
        prev.map((stage) => {
          const quantity = result.data.quantityKamban.find(
            (q) =>
              q.id === stage.id || (stage.id === 'no-status' && q.id === null)
          );

          return quantity
            ? { ...stage, count: parseInt(quantity.quantidade) }
            : stage;
        })
      );

      return true;
    } catch (error) {
      toast.error('Erro na atualização: ' + error.message, {
        autoClose: 3000,
        draggable: false
      });
      return false;
    }
  };

  const isToShowProtocolFiltersForm = (showProtocolFilters) => {
    const filters = getMemorizedFilters();
    const isToShow = !showProtocolFilters;

    if (filters) {
      filters.showProtocolFilters = isToShow;
    }

    setShowProtocolFilters(!showProtocolFilters);
    memorizeFilters(filters);
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <div className="d-flex flex-row justify-content-between">
                    <h3 className="mb-0">Protocolos</h3>
                    <div>
                      <ProtocolFieldsFilterToggle
                        className="small"
                        onClick={() =>
                          isToShowProtocolFiltersForm(showProtocolFilters)
                        }
                      >
                        {showProtocolFilters ? (
                          <>
                            <FiChevronUp size={18} /> Minimizar filtros{' '}
                          </>
                        ) : (
                          <>
                            <FiChevronDown size={18} /> Maximizar filtros{' '}
                          </>
                        )}
                      </ProtocolFieldsFilterToggle>

                      <span
                        onClick={() => formRef.current.cleanFilters()}
                        className="small"
                        style={{ cursor: 'pointer' }}
                      >
                        <AiOutlineClear /> Limpar filtros
                      </span>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-2">
                  {showProtocolFilters && (
                    <FiltersForm
                      ids={rowsSelectds}
                      defaultFields={protocolDefaultFieldsDisplaySettings}
                      handleGetProtocols={handleGetProtocols}
                      handleGetProtocolsOverallSLAInfo={
                        handleGetProtocolsOverallSLAInfo
                      }
                      canSeeAllProtocols={canSeeAllProtocols}
                      dateRules={dateRules}
                      getMediaPath={getMediaPath}
                      quantity={parseInt(protocolsQuantity) || 0}
                      ref={formRef}
                      isDisableClickToCall={disableClickToCall}
                      recordTypes={recordTypes}
                      selectedRecordType={selectedRecordType}
                      handleSelectedRecordTypeChange={
                        handleSelectedRecordTypeChange
                      }
                      setShowTable={setSelectedView}
                      showTable={selectedView}
                      setActivePage={setActivePage}
                      activePage={activePage}
                      sortOrder={sortOrder}
                      orderByFilter={orderByFilter}
                      itemsPerPage={itemsPerPage}
                      setItemsPerPage={setItemsPerPage}
                      setTypeReportSelected={setTypeReportSelected}
                      typeReportSelected={typeReportSelected}
                      setDataGrafics={setDataGrafics}
                      setLoaderGrafics={setLoaderGrafics}
                      hasChangedRecordType={hasChangedRecordType}
                      setHasChangedRecordType={setHasChangedRecordType}
                      callBackShowAdvancedFilters={(value) => {
                        setShowAdvancedFilters(value);
                      }}
                      isRecordTypeUsingSLA={isRecordTypeUsingSLA}
                      formatParamsSLAParams={formatParamsSLAParams}
                      isPageReloaded={isPageReloaded}
                      isListenerOnRecordType={isListenerOnRecordType}
                      setIsListenerOnRecordType={setIsListenerOnRecordType}
                    />
                  )}
                </CardBody>

                {isLoadingProtocols ? (
                  <div className="col-12">
                    <Row className="justify-content-md-center">
                      <Loader />
                    </Row>
                  </div>
                ) : (
                  <>
                    {typeReportSelected === 'Analítico' && (
                      <>
                        {selectedView === 'TABLE' && (
                          <Table
                            protocols={protocols || []}
                            protocolOverallSLAInfo={protocolOverallSLAInfo}
                            formatColumn={formatColumn}
                            loading={isLoadingProtocols}
                            quantity={parseInt(protocolsQuantity) || 0}
                            activePage={activePage}
                            handlePageChange={handlePageChange}
                            setOrderByColumn={setOrderByColumn}
                            orderByColumn={orderByColumn}
                            handleSortProtocolTable={handleSortProtocolTable}
                            sortOrder={sortOrder}
                            setSortOrder={setSortOrder}
                            itemsPerPage={itemsPerPage}
                            quantityCustomFields={customFields?.length}
                            showAdvancedFilters={showAdvancedFilters}
                            sortDirection={sortDirection}
                            setSortDirection={setSortDirection}
                            isRecordTypeUsingSLA={isRecordTypeUsingSLA}
                            getMemorizedFilters={getMemorizedFilters}
                          />
                        )}
                        {selectedView === 'KANBAN' && (
                          <>
                            <KanbanProtocol
                              data={kanbanDataArray}
                              onTableChange={onTableChange}
                              opportunityStages={status}
                              InfoCard={InfoCardProtocol}
                              isProtocol={true}
                              handleCall={handleCall}
                              disableClickToCall={disableClickToCall}
                              onTableGrow={onTableGrow}
                              stagePageInfo={stagePageInfo}
                            ></KanbanProtocol>
                          </>
                        )}
                        {selectedView === 'SPLIT' && (
                          <ListView
                            data={splitViewData}
                            slaColumnInfo={createSLAColumn}
                            customFields={customFields}
                            handleUpdate={handleUpdate}
                            handleCall={handleCall}
                            disableClickToCall={disableClickToCall}
                            protocolDefaultFieldsDisplaySettings={
                              protocolDefaultFieldsDisplaySettings
                            }
                            stagePageInfo={stagePageInfoSplitView}
                            status={status}
                            onTableGrow={onTableGrowSplitView}
                          ></ListView>
                        )}
                      </>
                    )}
                    {dataGrafics && typeReportSelected === 'Sintético' && (
                      <Graphics protocolsData={dataGrafics} />
                    )}
                  </>
                )}
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ProtocolListing;
